import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import logo from "../../app/assets/img/preloader1.gif";
import { useParams } from "react-router-dom";
import { getToken } from "../../app/auth/authConfig";

const PowerBiReport = ({ pagename }) => {
  const [powerbiReport, setPowerbiReport] = useState({});
  const [loading, setLoading] = useState(true);
  const [powerbiLoading, setpowerbiLoading] = useState(true);
  const [reportPages, setReportPages] = useState([]);
  const [activePageName, setActivePageName] = useState("");
  const [embeddedReport, setEmbeddedReport] = useState(null);

  const { reportnewid } = useParams();

  const powerbiReportData = useCallback(async () => {
    try {
      const baseurl = `${process.env.REACT_APP_BACKEND_API_URL}/api/tools/embed/${reportnewid}`;
      const token = await getToken();

      const response = await axios.get(baseurl, {
        headers: { "oidc-token": token },
      });

      if (response.status === 200) {
        console.log("token generated successfully:", response.data);
        setLoading(false);
        setPowerbiReport(response.data);
        return response.data;
      } else {
        console.error(
          "Error posting FAQ data:",
          response.status,
          response.statusText
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("Error posting FAQ data:", error);
      setLoading(false);
    }
  }, [reportnewid]);

  useEffect(() => {
    powerbiReportData();
  }, [powerbiReportData]);

  const loadReportPages = async (reportInstance) => {
    if (!reportInstance) {
      return;
    }

    try {
      const pages = await reportInstance.getPages();
      const visiblePages = (pages || []).filter((page) => {
        if (typeof page?.isHidden === "boolean") {
          return !page.isHidden;
        }
        if (typeof page?.visibility === "string") {
          return page.visibility.toLowerCase() !== "hidden";
        }
        return true;
      });

      setReportPages(visiblePages);

      const requestedPage = (pagename || "").trim();
      const requestedPageExists = visiblePages.some(
        (page) => page.name === requestedPage
      );

      if (requestedPageExists) {
        setActivePageName(requestedPage);
        return;
      }

      const activePage =
        visiblePages.find((page) => page.isActive) || visiblePages[0];
      setActivePageName(activePage?.name || "");
    } catch (error) {
      console.error("Failed to load report pages:", error);
    }
  };

  const embdData = (embeddedReport) => {
    window.report = embeddedReport;
    setEmbeddedReport(embeddedReport);
    window.report.on("loaded", async function () {
      await loadReportPages(window.report);
    });
  };

  const onPageTabClick = async (page) => {
    if (!page || !embeddedReport) {
      return;
    }

    try {
      await page.setActive();
      setActivePageName(page.name);
    } catch (error) {
      console.error("Failed to switch report page:", error);
    }
  };

  const token = powerbiReport.embedToken;
  const url = powerbiReport.reportURL;
  const reportGId = powerbiReport.reportGuid;

  return (
    <div>
      {!loading && reportPages.length > 0 && (
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            overflowX: "auto",
            padding: "0.75rem 0 0.9rem",
            borderBottom: "1px solid #e5e7eb",
            marginBottom: "0.75rem",
          }}
        >
          {reportPages.map((page) => {
            const isActive = activePageName === page.name;
            return (
              <button
                key={page.name}
                type="button"
                onClick={() => onPageTabClick(page)}
                style={{
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "0.88rem",
                  fontWeight: 600,
                  padding: "0.5rem 0.9rem",
                  whiteSpace: "nowrap",
                  color: isActive ? "#ffffff" : "#1f2937",
                  background: isActive ? "#0f5ca8" : "#eef2f7",
                  transition: "all 0.2s ease",
                }}
                aria-pressed={isActive}
                title={page.displayName || page.name}
              >
                {page.displayName || page.name}
              </button>
            );
          })}
        </div>
      )}

      <div style={{ height: "85vh" }}>
        {powerbiLoading && (
          <div
            style={{
              position: "absolute",
              background: "#ffffff",
              height: "100%",
              left: "0",
              right: "0",
              top: "0",
              bottom: "0",
              overflow: "hidden",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                height: "100%",
                overflow: "hidden",
                gap: "1rem",
              }}
            >
              <img src={logo} alt="logo" width={100} />

              <span style={{ color: "white" }}>Please wait...</span>
            </div>
          </div>
        )}

        {!loading && (
          <>
            <PowerBIEmbed
              embedConfig={{
                type: "report",
                id: reportGId,
                embedUrl: url,
                accessToken: token,
                pageName: activePageName || pagename || undefined,
                tokenType: models.TokenType.Embed,

                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                    pageNavigation: {
                      visible: false,
                    },
                  },
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    async function () {
                      console.log("Report loaded");
                      if (window.report) {
                        await loadReportPages(window.report);
                      }
                      setpowerbiLoading(false);
                    },
                  ],
                  [
                    "rendered",
                    function () {
                      console.log("Report rendered");
                    },
                  ],
                  [
                    "error",
                    function (event) {
                      console.log(event.detail);
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  [
                    "pageChanged",
                    (event) => {
                      const pageName = event?.detail?.newPage?.name;
                      if (pageName) {
                        setActivePageName(pageName);
                      }
                      console.log(event);
                    },
                  ],
                ])
              }
              cssClassName={"report-style-class"}
              getEmbeddedComponent={embdData}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PowerBiReport;